import { createAsyncThunk } from '@reduxjs/toolkit';

import { type TJsonQuery } from '@/packages/JsonQuery';

import { fetchGetCities, prepareCities } from '@/microfrontends/filters/shared/services/fetchCities';
import { type ILocation, type TLocation } from '@/microfrontends/filters/shared/types/location';

import { type TThunkApi } from '../../types';

interface IOpenResult {
  selectedRegion: TLocation | undefined;
  selectedCity: ILocation | undefined;
  cities: ILocation[];
  jsonQuery: TJsonQuery;
}

export const open = createAsyncThunk<IOpenResult, undefined, TThunkApi>(
  'locationPopup/open',
  async (_, thunkApi) => {
    const { extra, getState } = thunkApi;

    const state = getState();

    const subdomain = extra.custom.subdomain;
    const jsonQuery = state.jsonQuery.current;
    const currentLocation = state.location.data;
    let selectedRegion: TLocation | undefined;
    let selectedCity: ILocation | undefined;
    let cities: ILocation[] = [];

    if (currentLocation === 'moscow_mo' || currentLocation === 'spb_lo') {
      selectedRegion = currentLocation;
    } else if (currentLocation.parentId) {
      selectedCity = currentLocation;
      selectedRegion = findRegion(state.regions, currentLocation.parentId);
      const citiesResponse = await fetchGetCities(extra, { regionId: currentLocation.parentId }, { subdomain });
      cities = citiesResponse.map(prepareCities).unwrapOr([]);
    } else {
      selectedRegion = currentLocation;
      const citiesResponse = await fetchGetCities(extra, { regionId: currentLocation.id }, { subdomain });
      cities = citiesResponse.map(prepareCities).unwrapOr([]);
    }

    return {
      selectedCity,
      selectedRegion,
      cities,
      jsonQuery,
    };
  },
  {
    condition: (_, thunkApi) => {
      const state = thunkApi.getState();

      return state.locationPopup.status !== 'loading';
    },
  },
);

function findRegion(regions: ILocation[], id: number): ILocation | undefined {
  return regions.filter(region => region.id === id).shift();
}
